import LinearProgress from '@mui/material/LinearProgress';
const Loader = () => {
    return  <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 9999 }}>
       <LinearProgress  />
    </div>
}
export default Loader;